import { ReactNode } from "react";
import { CardDescription, CardTitle } from "@/shared/ui/card";

interface AuthHeaderProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
}

export function AuthHeader({
  title,
  description,
  icon,
  className = ""
}: AuthHeaderProps) {
  return (
    <div className="text-center space-y-2">
      {icon && (
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-500/10 mb-4">
          {icon}
        </div>
      )}
      <CardTitle className={`text-2xl font-semibold tracking-tight text-white ${className}`}>
        {title}
      </CardTitle>
      {description && (
        <CardDescription className="text-white/60">
          {description}
        </CardDescription>
      )}
    </div>
  );
}

export function LogoHeader() {
  return (
    <div className="flex justify-center mb-6">
      <img
        src="/lovable-uploads/9fa11231-25ce-4026-9b1f-834785684e58.png"
        className="h-8"
        alt="LikeAPPro Logo"
      />
    </div>
  );
}
